import styled from 'styled-components';

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Svg = styled.svg`
  margin: auto;
  background: none;
  display: block;
`;
